import {DeviceContinuity} from './components/DeviceContinuity';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './lib/auth';
import { App } from './App';
import './globals.css';

const queryClient = new QueryClient({
    defaultOptions: {
        mutations:{networkMode:'always',retry:false},
        queries: {
            networkMode: 'always',
            staleTime: 30_000,
            retry: 1,
            refetchOnWindowFocus: false,
        },
    },
});

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');

createRoot(root).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <AuthProvider>
                    <DeviceContinuity><App /></DeviceContinuity>
                </AuthProvider>
            </BrowserRouter>
        </QueryClientProvider>
    </StrictMode>,
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
    window.addEventListener('load',()=>{void navigator.serviceWorker.register('/offline-sw.js').catch(()=>{console.warn('Offline app loading is not available on this browser.');});});
}

window.addEventListener('pamosi-offline-synced',()=>{void queryClient.invalidateQueries();});
